import React from 'react';
import PropTypes from 'prop-types';

import { MssgmeLogo } from '@mssgme/ui';
import { main_url } from 'config';

import styles from './styles.scss';

export default function AuthLayout({ children }) {
    return (
        <div className={styles.root}>
            <div className={styles.contentContainer}>
                <div className={styles.content}>
                    <div className={styles.header}>
                        <a href={main_url} className={styles.logo}>
                            <MssgmeLogo />
                        </a>
                    </div>
                    <div className={styles.pane}>{children}</div>
                </div>
            </div>
        </div>
    );
}

AuthLayout.propTypes = {
    children: PropTypes.any,
};
